import MitForm from '../components/Form/Form'
import { Container } from '@mui/material'

const styles = {
  container: {
    padding: '32px 16px',
    maxWidth: '1024px'
  },
  header: {
    fontWeight: 700,
    fontSize: '34px',
    fontFamily: 'NeueHaasDisplayBold',
    lineHeight: '42.5px',
    letterSpacing: '0%',
    marginBottom: '32px'
  },
  subHeader: {
    fontSize: '17px',
    color: 'rgba(0, 0, 0, 1)',
    fontFamily: 'NHaasGroteskTXPro-65Rg',
    marginBottom: '16px'
  },
  description: {
    fontWeight: 400,
    fontSize: '17px',
    color: 'rgba(0, 0, 0, 0.75)',
    fontFamily: 'NHaasGroteskTXPro-55Rg',
    marginBottom: '16px'
  },
  description_i: {
    fontWeight: 400,
    fontSize: '17px',
    fontStyle: 'italic',
    color: 'rgba(0, 0, 0, 0.75)',
    fontFamily: 'NHaasGroteskTXPro-55Rg',
    marginBottom: '16px'
  }
}

export function Home() {
  return (
    <Container style={styles.container}>
      <div style={styles.header}>
        Sign up to receive Commencement week text notifications
      </div>
      <div style={styles.subHeader}>
        Will you be attending any of MIT’s 2025 Commencement ceremonies as the guest of a graduate? If so, you may sign up using the form below to receive important ceremony-related information during Commencement week—such as last-minute changes to ceremony or reception locations—via text message. You will be able to unsubscribe from these notifications by replying STOP any time or via the <a href="/unsubscribe">unsubscribe form</a>.
      </div>
      <div style={styles.description_i}>
        NOTE: Text notifications sent to guests will be strictly regarding ceremony-specific information during Commencement week. Important Commencement-related updates and reminders from the Registrar’s Office and MIT Commencement are sent to your graduate, so remind them to continue to watch their MIT email inbox for such messages. Visit the <a href="https://commencement.mit.edu/graduates/graduation-checklist">Commencement website</a> for the most up-to-date information for graduates and their guests.
      </div>
      <MitForm isUnsubscribe={false} />

      <div className='resubscribe-wrapper'>
        <a className="resubscribe" href="/unsubscribe">
          Unsubscribe Instead?
        </a>
      </div>
    </Container>
  )
}
